import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class OperatorsService {

  OPERATORS_API_BASE_URL = SERVER_API_URL + 'operators/countries/';

  constructor(private http: HttpClient) { }

  getOperators(regionCodes: string[]): Observable<any> {
    let params = new HttpParams();
    for (const regionCode of regionCodes) {
      params = params.append('regionCode', regionCode);
    }
    return this.http.get<any>(this.OPERATORS_API_BASE_URL, { params });
  }
}
